






































































































































































































export default {
    props: {

        source: String,
        seen: false,
        inMenu: false,
        isMenu: false,
        title: "",
        text: ""
    },

    data: () => ({
        cardView: true,
        filtered: false,

        fileActions: [
            { title: 'Duplicate', icon: 'mdi-content-copy' },
            { title: 'Edit', icon: 'mdi-file-document-edit' },
            { title: 'Move', icon: 'mdi-file-move' },
            { title: 'Delete', icon: "mdi-trash-can" },
        ],
        headers: [
            // {
            //     text: 'File Type',
            //     align: 'left',
            //     sortable: false,
            //     value: 'icon',
            // },
            {
                text: 'File name',
                sortable: true,
                value: 'title',
            },
            { text: 'Date Modified', value: 'date' },
            { text: 'Modified By', value: 'modifiedBy' },
            { text: 'Size', value: 'size' },
        ],
        folders: [{
                title: "Lorem ipsum 1",
                type: "folder",
                icon: "mdi-folder",
                date: "Apr 20, 2018",
                modifiedBy: "User McUserface",
                size: "59,000,000",
            },
            {
                title: "Lorem ipsum 1",
                type: "folder",
                icon: "mdi-folder",
                date: "Apr 20, 2018",
                modifiedBy: "User McUserface",
                size: "59,000,000",
            },
            {
                title: "Lorem ipsum 1",
                type: "folder",
                icon: "mdi-folder",
                date: "Apr 20, 2018",
                modifiedBy: "User McUserface",
                size: "59,000,000",
            },
            {
                title: "Lorem ipsum 1",
                type: "folder",
                icon: "mdi-folder",
                date: "Apr 20, 2018",
                modifiedBy: "User McUserface",
                size: "59,000,000",
            },
        ],
        docs: [{
                title: "Word File",
                type: "docx",
                icon: "mdi-file-word",
                date: "Apr 20, 2018",
                modifiedBy: "User McUserface",
                size: "128kb",
            },
            {
                title: "PDF File",
                type: "pdf",
                icon: "mdi-file-pdf",
                date: "Apr 20, 2018",
                modifiedBy: "User McUserface",
                size: "1.5mb",
            },
            {
                title: "Power point",
                type: "ppt",
                icon: "mdi-file-powerpoint",
                date: "Apr 20, 2018",
                modifiedBy: "User McUserface",
                size: "156gb",
            },
            {
                title: "Excel",
                type: "xcl",
                icon: "mdi-file-excel",
                date: "Apr 20, 2018",
                modifiedBy: "User McUserface",
                size: "123mb",
            },
            {
                title: "Other",
                type: "png",
                icon: "",
                date: "Apr 20, 2018",
                modifiedBy: "User McUserface",
                size: "123mb",
            },
        ],
        items: [{
                text: 'Dashboard',
                disabled: false,
                href: 'breadcrumbs_dashboard',
            },
            {
                text: 'Link 1',
                disabled: false,
                href: 'breadcrumbs_link_1',
            },
            {
                text: 'Link 2',
                disabled: true,
                href: 'breadcrumbs_link_2',
            },
        ],

    }),
    methods: {



    }
}
